var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ins',{staticClass:"adsbygoogle",staticStyle:{"display":"block"},attrs:{"data-ad-client":"ca-pub-7098941501180575","data-ad-format":"fluid","data-full-width-responsive":"true","data-ad-slot":2856092344}})}
var staticRenderFns = []

export { render, staticRenderFns }